export const phoneNumberPrefixes = [
  { label: '+52', value: '+52' },
  { label: '+1', value: '+1' },
];

export const ALERT_TYPES = {
  SUCCESS: 'success',
  ERROR: 'danger',
  INFO: 'info',
};

export const DELETE_TIME = 20000;
export const DELETE_TIME_SUCCESS = 2000;

export const ROLES = {
  MEMBER: 'Member',
  ADMIN: 'Admin',
  OWNER: 'Owner'
};

export const GENDERS = [
  { code: 'M', name: 'Male' },
  { code: 'F', name: 'Female' },
];

export const DASHBOARD_SECTIONS = {
  DRAFT: 'draft',
  IN_PROGRESS: 'inProgress',
  ARRIVED: 'arrived',
  RELEASED: 'released',
};

export const STATUS = {
  inactive: "Draft",
  readyToSend: "Draft",
  readyToSendForDeletion: "Draft",
  readyToSendForEdition: "Draft",

  sent: "Sent",
  sendingShipments: "Sending Shipments",
  sentTripPortion: "Sent",
  sentClosingTrip: "Sent",
  sentForUdateTripPortion: "Sent",
  sentForUpdateClosingTrip: "Sent",
  sentForDeletion: "Sent",
  sentForEdition: "Sent",
  sentForClosingTripPortion: "Sent",

  acceptedTripPortion: "Accepted",
  acceptedClosingTrip: "Accepted",
  acceptedUpdateTripPortion: "Accepted",
  acceptedUpdateClosingTrip: "Accepted",
  accepted: "Accepted",
  editionAccepted: "Accepted",

  deletionAccepted: "Deleted",

  receivedClosingTrip: "Received",
  receivedTripPortion: "Received",
  receivedUpdateTripPortion: "Received",
  receivedUpdateClosingTrip: "Received",
  syntaxAccepted: "Received",
  received: "Received",
  editionReceived: "Received",
  deletionReceived: "Received",
  responsesReceived: "Responses Received",

  rejectedClosingTrip: "Rejected",
  rejectedTripPortion: "Rejected",
  editionRejected: "Rejected",
  rejectedUpdateTripPortion: "Rejected",
  deletionRejected: "Rejected",
  editionRejected: "Rejected",
  rejected: "Rejected",
  rejectedReturnToPreliminary: "Rejected",
  deletionRejected: "Rejected",

  syntaxRejected: "Rejected",
  syntaxError: "Rejected",

  arrived: "Arrived",
  released: "Released",
  entryOnFile: "Entry On File",
  entryNotOnFile: "Entry Not On File"
};

export const STATUS_COMPLETE = {
  inactive: "Inactive",
  readyToSend: "Ready To Send",
  readyToSendForDeletion: "Ready To Send For Deletion",
  readyToSendForEdition: "Ready To Send For Edition",

  sent: "Sent",
  sendingShipments: "sending Shipments",
  sentTripPortion: "Sent Trip Portion",
  sentClosingTrip: "Sent Closing Trip",
  sentForUdateTripPortion: "Sent For Update Trip Portion",
  sentForUpdateClosingTrip: "Sent For Update Closing Trip",
  sentForDeletion: "Sent For Deletion",
  sentForEdition: "Sent For Edition",
  sentForClosingTripPortion: "Sent For Closing Trip Portion",

  acceptedTripPortion: "Accepted Trip Portion",
  acceptedClosingTrip: "Accepted Closing Trip",
  acceptedUpdateTripPortion: "Accepted Update Trip Portion",
  acceptedUpdateClosingTrip: "Accepted Update Closing Trip",
  deletionAccepted: "Deletion Accepted",
  accepted: "Accepted",
  editionAccepted: "Edition Accepted",

  deletionAccepted: "Deletion Accepted",

  receivedClosingTrip: "Received Closing Trip",
  receivedTripPortion: "Received Trip Portion",
  receivedUpdateTripPortion: "Received Update Trip Portion",
  receivedUpdateClosingTrip: "Received Update Closing Trip",
  syntaxAccepted: "Syntax Accepted",
  received: "Received",
  editionReceived: "Edition Received",
  deletionReceived: "Deletion Received",
  responsesReceived: "Responses Received",

  rejectedClosingTrip: "Rejected Closing Trip",
  rejectedTripPortion: "Rejected Trip Portion",
  editionRejected: "Ddition Rejected",
  rejectedUpdateTripPortion: "Rejected Update Trip Portion",
  deletionRejected: "Deletion Rejected",
  rejected: "Rejected",
  rejectedReturnToPreliminary: "Rejected - Return To Preliminary",

  syntaxRejected: "Syntax Error",
  syntaxError: "Syntax Error",

  arrived: "Arrived",
  released: "Released",
  entryOnFile: "Entry On File",
  entryNotOnFile: "entry Not On File"
};
export const SHIPMENT_STATUS = {
  accepted: 'Accepted',
  sent: 'Sent to CBP',
  rejected: 'Rejected',
  "02": "Entry on file",
  "05": "QP on file",
  "06": "Duplicate in-bond request via QP, carrier's in-bond accepted",
  "11": "Arrival of in-bond-complete movement",
  "12": "Arrival of in-bond-bill of lading",
  "13": "Arrival of in-bond-container",
  "18": "Master in-bond advisory",
  "1A": "Entered: Intensive examination required",
  "1B": "Released: Intensive examination completed",
  "1C": "Entered and released: general examination",
  "1F": "Customs hold removed at port of in-bond destination",
  "1G": "Customs hold placed at port of in-bond destination",
  "1H": "Customs hold placed at port of discharge",
  "1I": "Customs hold removed at port of discharge",
  "1J": "In-bond Movement Authorized: bill of Lading open",
  "1K": "Bill of lading late in 5 days",
  "1L": "Bill of lading late",
  "1N": "Overage",
  "1O": "Shortage",
  "1R": "Pending eligible general order",
  "1S": "Ordered to general order",
  "1T": "Seized",
  "1U": "Sent to general order",
  "2F": "USDA Miscellaneous hold removed at port of in-bond destination",
  "2G": "USDA miscellaneous hold placed at port of in-bond destination",
  "2H": "USDA miscellaneous hold placed at port of discharge",
  "2I": "USDA miscellaneous hold removed at port of discharge",
  "3F": "Other government agency hold removed at port of in-bond destination",
  "3G": "Other government agency hold placed at port of in-bond destination",
  "3H": "Other government agency hold placed at port of discharge",
  "3I": "Other government agency hold removed at port of discharge",
  "3W": "Request for In-bond Diversion granted",
  "4A": "Override",
  "4C": "Override",
  "4E": "Entry cancelled",
  "4H": "Invalid shipper hold placed",
  "4I": "Invalid shipper hold removed",
  "4J": "Sec 321 Hold - max daily value of $800 exceeded by CNE",
  "4K": "Sec 321 Hold Removal - max daily value exceeded by CNE",
  "50": "Export of in-bond-complete movement",
  "51": "Export of in-bond-bill of lading",
  "52": "Export of in-bond-container",
  "53": "Overdue export",
  "57": "Change arrival of in-bond-complete movement",
  "58": "Change arrival of in-bond-bill of lading",
  "59": "Change arrival of in-bond-container",
  "5H": "Entry processing hold",
  "5I": "Entry processing hold removed",
  "60": "Change export of in-bond-complete movement",
  "61": "Change export of in-bond-bill of lading",
  "62": "Change export of in-bond-container",
  "63": "Cancel arrival of in-bond-complete movement",
  "64": "Cancel arrival of in-bond-bill of lading",
  "65": "Cancel arrival of in-bond-container",
  "66": "Cancel export of in-bond-complete movement",
  "67": "Cancel export of in-bond-bill of lading",
  "68": "Cancel export of in-bond-container",
  "69": "Bill on file",
  "71": "Intensive hold for USDA placed at port of discharge",
  "72": "Inspection/document review for USDA placed at the port of discharge",
  "73": "Fumigation hold for USDA placed at the port of discharge",
  "74": "Intensive hold for USDA removed at port of discharge",
  "75": "Inspection/document review for USDA removed at the port of discharge",
  "76": "Fumigation hold for USDA removed at the port of discharge",
  "77": "Intensive hold for USDA placed at port of in-bond destination",
  "78": "Inspection/document review for USDA placed at the port of in-bond destination",
  "79": "Fumigation hold for USDA placed at the port of in-bond destination",
  "80": "Intensive hold for USDA removed at port of in-bond destination",
  "81": "Inspection/document review for USDA removed at the port of in-bond destination",
  "82": "Fumigation hold for USDA removed at the port of in-bond destination",
  "8H": "Invalid cargo description hold placed",
  "8I": "Invalid cargo description hold removed",
  "9H": "Invalid consignee hold placed",
  "9I": "Invalid consignee hold removed",
  "92": "Section 321 BOL removed from manifest",
  "93": "BOL added to manifest",
  "94": "BOL removed from manifest",
  "95": "Section 321's maximum daily value of $800 may be exceeded by consignee",
  "A1": "PN on file",
  "A4": "Entry not on file",
  "A5": "PN not on file",
  "AA": "Shipment Accepted",
  "M1": "Pedimento Validado",
  "M2": "Pedimento Pagado",
  "M3": "Pedimento Desaduanado",
  "M4": "Pedimento Cumplido",
  "M5": "Pedimento - Verde en Primera Selección",
  "M6": "Pedimento - Verde en Segunda Selección",
  "M7": "Pedimento - Rojo en Primera Selección",
  "M8": "Pedimento - Inicio Primer Reconocimiento",
  "M9": "Pedimento - Resultado sin Incidencias",
  "PM": "Entry port code mismatch",
  "D2": "Seal added to equipment by Customs",
  "D3": "Seal removed from equipment by Custom"
}

export const STATUS_COLORS = {
  inactive: { label: 'Inactive', color: 'bg-gray-300' },
  readyToSend: { label: 'Ready To Send', color: 'bg-primary-400' },
  readyToSendForDeletion: { label: 'Ready To Send For Deletion', color: 'bg-primary-400' },
  readyToSendForEdition: { label: 'Ready To Send For Edition', color: 'bg-primary-400' },

  sent: { label: 'Sent For Creation', color: 'bg-primary-400' },
  sendingShipments: { label: 'Sending Shipments', color: 'bg-primary-400' },
  sentTripPortion: { label: 'Sent Trip Portion', color: 'bg-primary-400' },
  sentClosingTrip: { label: 'Sent Closing Trip', color: 'bg-primary-400' },
  sentForUdateTripPortion: { label: 'Sent For Update Trip Portion', color: 'bg-primary-400' },
  sentForUpdateClosingTrip: { label: 'Sent For Update Closing Trip', color: 'bg-primary-400' },
  sentForDeletion: { label: 'Sent For Deletion', color: 'bg-primary-400' },
  sentForEdition: { label: 'Sent For Edition', color: 'bg-primary-400' },
  sentForClosingTripPortion: { label: 'Sent For Closing Trip Portion', color: 'bg-primary-400' },

  acceptedTripPortion: { label: 'Accepted Trip Portion', color: 'bg-primary-400' },
  acceptedClosingTrip: { label: 'Accepted Closing Trip', color: 'bg-primary-400' },
  acceptedUpdateTripPortion: { label: 'Accepted Update Trip Portion', color: 'bg-primary-400' },
  acceptedUpdateClosingTrip: { label: 'Accepted Update Closing Trip', color: 'bg-primary-400' },
  deletionAccepted: { label: 'Deletion Accepted', color: 'bg-primary-400' },
  accepted: { label: 'Creation Accepted', color: 'bg-primary-400' },
  editionAccepted: { label: 'Edition Accepted', color: 'bg-primary-400' },
  deletionAccepted: { label: 'Deletion Accepted', color: 'bg-primary-400' },
  editionAccepted: { label: 'Edition Accepted', color: 'bg-primary-400' },


  receivedClosingTrip: { label: 'Received Closing Trip', color: 'bg-primary-400' },
  receivedTripPortion: { label: 'Received Trip Portion', color: 'bg-primary-400' },
  receivedUpdateTripPortion: { label: 'Received Update Trip Portion', color: 'bg-primary-400' },
  receivedUpdateClosingTrip: { label: 'Received Update Closing Trip', color: 'bg-primary-400' },
  syntaxAccepted: { label: 'Syntax Accepted', color: 'bg-primary-400' },
  received: { label: 'Creation Received', color: 'bg-primary-400' },
  editionReceived: { label: 'Edition Received', color: 'bg-primary-400' },
  deletionReceived: { label: 'Deletion Received', color: 'bg-primary-400' },
  responsesReceived: { label: 'Responses Received', color: 'bg-primary-400' },

  rejectedClosingTrip: { label: 'Rejected Closing Trip', color: 'bg-red-400' },
  rejectedTripPortion: { label: 'Rejected Trip Portion', color: 'bg-red-400' },
  editionRejected: { label: 'Edition Rejected', color: 'bg-red-400' },
  rejectedUpdateTripPortion: { label: 'Rejected Update Trip Portion', color: 'bg-red-400' },
  deletionRejected: { label: 'Deletion Rejected', color: 'bg-red-400' },
  editionRejected: { label: 'Edition Rejected', color: 'bg-red-400' },
  rejected: { label: 'Creation Rejected', color: 'bg-red-400' },
  deletionRejected: { label: 'Deletion Rejected', color: 'bg-red-400' },
  rejectedReturnToPreliminary: { label: 'Rejected - Return To Preliminary', color: 'bg-red-400' },
  syntaxRejected: { label: 'Syntax Error', color: 'bg-red-400' },
  syntaxError: { label: 'Syntax Error', color: 'bg-red-400' },

  arrived: { label: 'Arrived', color: 'bg-yellow-400' },
  released: { label: 'Released', color: 'bg-green-500' },
  entryOnFile: { label: 'Entry On File', color: 'bg-primary-400' },
  entryNotOnFile: { label: 'Entry Not On File', color: 'bg-yellow-400' },
};

export const STATUS_BOOL_COLORS = {
  active: { label: 'Active', color: 'bg-primary-400' },
  inactive: { label: 'Inactive', color: 'bg-red-400' },
};

export const TRIP_STATUS = {
  RELEASED: {
    KEY: 'RELEASED',
    VALUE: ['released'],
    COLOR: 'bg-green-500',
    TEXT_COLOR: 'text-green-500',
    LABEL_COLOR: 'text-white',
    LABEL: 'Released',
  },
  ERROR: {
    KEY: 'ERROR',
    VALUE: [
      'rejectedClosingTrip',
      'rejectedTripPortion',
      'editionRejected',
      'rejectedUpdateTripPortion',
      'deletionRejected',
      'editionRejected',
      'rejected',
      'deletionRejected',
      'rejectedReturnToPreliminary',
      'syntaxRejected',
      'syntaxError',
      'deletionAccepted',
      'responsesReceived'
    ],
    COLOR: 'bg-red-400',
    TEXT_COLOR: 'text-red-400',
    LABEL_COLOR: 'text-white',
    LABEL: {
      rejectedClosingTrip: "Rejected Rejected",
      rejectedTripPortion: "Rejected Trip Portion",
      editionRejected: "Edition Rejected",
      rejectedUpdateTripPortion: "Rejected Trip Portion",
      deletionRejected: "Deletion Rejected",
      editionRejected: "Edition Rejected",
      rejected: "Rejected",
      deletionRejected: "Deletion Rejected",
      rejectedReturnToPreliminary: "Rejected - Return To Preliminary",
      syntaxRejected: "Syntax Error",
      syntaxError: "Syntax Error",
      deletionAccepted: "Deleted",
      responsesReceived: "Shipments with error",
    },
  },
  IN_PROGRESS: {
    KEY: 'IN_PROGRESS',
    VALUE: [
      'readyToSend',
      'readyToSendForDeletion',
      'readyToSendForEdition',

      'sent',
      'sendingShipments',
      'responsesReceived',
      'sentTripPortion',
      'sentClosingTrip',
      'sentForUdateTripPortion',
      'sentForUpdateClosingTrip',
      'sentForDeletion',
      'sentForEdition',
      'sentForClosingTripPortion',

      'acceptedTripPortion',
      'acceptedClosingTrip',
      'acceptedUpdateTripPortion',
      'acceptedUpdateClosingTrip',

      'accepted',
      'editionAccepted',

      'editionAccepted',

      'receivedClosingTrip',
      'receivedTripPortion',
      'receivedUpdateTripPortion',
      'receivedUpdateClosingTrip',
      'syntaxAccepted',
      'received',
      'editionReceived',
      'deletionReceived',
    ],
    COLOR: 'bg-primary-400',
    TEXT_COLOR: 'text-primary-400',
    LABEL_COLOR: 'text-white',
    LABEL: {
      readyToSend: "Ready To Send",
      readyToSendForDeletion: "Ready To Send",
      readyToSendForEdition: "Ready To Send",

      sent: "Sent",
      sendingShipments: "Sending Shipments",
      responsesReceived: "Responses Received",
      sentTripPortion: "Sent Trip Portion",
      sentClosingTrip: "Sent To Close",
      sentForUdateTripPortion: "Sent Update Trip Portion",
      sentForUpdateClosingTrip: "Sent To Close",
      sentForDeletion: "Sent For Deletion",
      sentForEdition: "Sent For Edition",
      sentForClosingTripPortion: "sent To Close",

      acceptedTripPortion: "Accepted",
      acceptedClosingTrip: "Accepted",
      acceptedUpdateTripPortion: "Accepted Trip Portion",
      acceptedUpdateClosingTrip: "Accepted",
      accepted: "Accepted",
      editionAccepted: "Accepted",

      editionAccepted: "Accepted",


      receivedClosingTrip: "Received",
      receivedTripPortion: "Received",
      receivedUpdateTripPortion: "Received",
      receivedUpdateClosingTrip: "Received",
      syntaxAccepted: "Received",
      received: "received",
      editionReceived: "Received",
      deletionReceived: "Received",
    },
  },
  ARCHIVED: {
    KEY: 'ARCHIVED',
    VALUE: 'archived',
    COLOR: 'bg-red-400',
    TEXT_COLOR: 'text-red-400',
    LABEL_COLOR: 'text-white',
    LABEL: 'Archived',
  },
  ARRIVED: {
    KEY: 'ARRIVED',
    VALUE: 'arrived',
    COLOR: 'bg-yellow-400',
    TEXT_COLOR: 'text-yellow-400',
    LABEL_COLOR: 'text-white',
    LABEL: 'Arrived',
  },
  DRAFT: {
    KEY: 'DRAFT',
    VALUE: ['draft', 'inactive'],
    COLOR: 'bg-gray-400',
    TEXT_COLOR: 'text-gray-700',
    LABEL_COLOR: 'text-gray-700',
    LABEL: 'Draft',
  },
};

export const TRIP_STATES = {
  INACTIVE: { VALUE: 'inactive' },
  ARRIVED: { VALUE: 'arrived' },
  RELEASED: { VALUE: 'released' },
  ENTRY_ON_FILE: { VALUE: 'entryOnFile' },
  ENTRY_NOT_ON_FILE: { VALUE: 'entryNotOnFile' },

  EDI_FILE_READY_TO_SEND: { VALUE: 'ediFileReadyToSend' },
  SENT_TO_CBP: { VALUE: 'sent' },
  SYNTAX_ACCEPTED: { VALUE: 'syntaxAccepted' },
  SYNTAX_REJECTED: { VALUE: 'syntaxRejected' },
  ACCEPTED_BY_CBP: { VALUE: 'accepted' },
  REJECTED_BY_CBP: { VALUE: 'rejected' },

  EDI_FILE_READY_TO_SEND_FOR_DELETION: { VALUE: 'ediFileReadyToSendForDeletion' },
  SENT_FOR_DELETION_TO_CBP: { VALUE: 'sentForDeletion' },
  DELETION_ACCEPTED: { VALUE: 'deletionAccepted' },
  DELETION_REJECTED: { VALUE: 'deletionRejected' },
  DELETION_ACCEPTED_BY_CBP: { VALUE: 'deletionAccepted' },
  DELETION_REJECTED_BY_CBP: { VALUE: 'deletionRejected' },

  EDI_FILE_READY_TO_SEND_FOR_EDITION: { VALUE: 'ediFileReadyToSendForEdition' },
  SENT_FOR_EDITION_TO_CBP: { VALUE: 'sentForEdition' },
  EDITION_ACCEPTED: { VALUE: 'editionAccepted' },
  EDITION_REJECTED: { VALUE: 'editionRejected' },
  EDITION_ACCEPTED_BY_CBP: { VALUE: 'editionAccepted' },
  EDITION_REJECTED_BY_CBP: { VALUE: 'editionRejected' },
};

export const DASHBOARD_VIEW_TYPE = {
  KANBAN: 'kanban',
  LIST: 'list',
  GRID: 'grid',
  KEY: 'VIEW_TYPE',
};

export const DASHBOARD_ITEM_TYPE = {
  TRIP: 'trip',
  SHIPMENT: 'shipments',
};

export const CATALOG = {
  EQUIPMENTS: 'equipments',
  CONVEYANCES: 'conveyances',
  DRIVERS: 'drivers',
  CARRIERS: 'carriers',
  PORTS: 'ports',
  PASSENGERS: 'passengers',
  FIRMS_CODE: 'firms',
  PORT_OF_LADINGS: 'portsOfLading'
};

export const DATE_PRESETS = {
  DEFAULT: 'Today',
  TODAY: 'Today',
  THIS_WEEK: 'This Week',
  THIS_MONTH: 'This Month',
};

export const DASHBOARD_SORT_OPTIONS = [
  { text: 'Ascending Estimated Arrival', value: 'AscendingEstimatedArrival', pair: 1 },
  { text: 'Descending Estimated Arrival', value: 'DescendingEstimatedArrival', pair: 1 },
  { text: 'Ascending Trip Number', value: 'AscendingTripNumber', pair: 2 },
  { text: 'Descending Trip Number', value: 'DescendingTripNumber', pair: 2 },
];

export const SHIPMENT_LAYOUT_TYPE = {
  LIST: 'LIST',
  SAVE: 'SAVE',
  EDIT: 'EDIT',
  EMPTY: 'EMPTY',
};

export const SHIPMENT_CATALOG_KEY = {
  SHIPMENT_TYPES: 'shipmentTypes',
  SHIPMENT_TYPES_CBSA: 'shipmentTypesCBSA',
  PORT_OF_LADINGS: 'portOfLadings',
  SHIPPERS: 'shippers',
  CONSIGNEES: 'consignees',
  UOMS: 'uoms',
  UOWS: 'uows',
  PARTIES: 'parties',
  COMMODITIES: 'commodities',
  SUBLOCATION_PORT: 'sublocations',
  PORTS: 'ports',
  CARRIERS: 'carriers',
  OUTBOUND_STATES: 'outboundStates',
  DESTINATION_PORT: 'destinationPort',
  OUTBOUND_PORT: 'outboundPort',
  FIRMS_CODE: 'firms',
  SECONDARY_CARRIERS: 'secondaryCarriers'
};

export const SHIPMENT_CATALOGS = [
  {
    name: SHIPMENT_CATALOG_KEY.PORT_OF_LADINGS,
    url: 'ports/lading',
  },
  {
    name: SHIPMENT_CATALOG_KEY.PARTIES,
    propName: 'shippers',
    url: 'parties?country=MX,CA',
  },
  {
    name: SHIPMENT_CATALOG_KEY.PARTIES,
    propName: 'consignees',
    url: 'parties?country=US',
  },
];

export const TRIP_CATALOGS = ['drivers', 'equipments', 'conveyances', 'passengers'];

export const CONVEYANCE_CATALOGS = ['conveyanceTypes'];
export const EQUIPMENT_CATALOGS = ['equipmentTypes'];

export const PAGINATOR_ACTIONS = {
  PREV: 'PREV',
  NEXT: 'NEXT',
  START_PAGE: 'START_PAGE',
  END_PAGE: 'END_PAGE',
};

export const SHIPMENT_TYPES = {
  REGULAR: 'Regular',
  QP_IN_BOND: 'QP In-Bond',
  SECTION_321: 'Section 321',
  IN_BOND: 'In-Bond',
  GN1_EXEMPTIONS: 'GN1 - Exemptions/Goods Astray',
  CARNET: 'Carnet',
  US_GOODS_RETURNED: '3311 - US Goods Returned',
  UNACCOMPANIED_ARTICLES: '3299 - Unaccompanied Articles',
  FREE_OF_DUTY: '7523 - Free of Duty',
};

export const SHIPMENT_TYPES_CBSA = {
  REGULAR: 'Regular',
  REGULAR_SECONDARY_CARRIER: 'Regular - Secondary Carrier',
  REGULAR_LINKED_SCN: 'Regular - Linked SCN',
  BONDED_SHIPMENT: 'Bonded Shipment',
};

export const SECTION_321_CSV_COLUMNS = {
  COLUMNS: {
    shipmentControlNumber: 'Shipment Control Number',
    shipmentType: 'Shipment Type',
    shipperName: 'Shipper Name',
    shipperAddress: 'Shipper Address',
    shipperCity: 'Shipper City',
    shipperCountry: 'Shipper Country',
    shipperState: 'Shipper State',
    shipperPostal: 'Shipper Postal',
    shipperPortOfLading: 'Shipper Port of Lading',
    consigneeName: 'Consignee Name',
    consigneeAddress: 'Consignee Address',
    consigneeCity: 'Consignee City',
    consigneeCountry: 'Consignee Country',
    consigneeState: 'Consignee State',
    consigneePostal: 'Consignee Postal',
    productDescription: 'Product Description',
    productQty: 'Product Qty',
    productUOM: 'Product UOM',
    productWeight: 'Product Weight',
    productUnitOfWeight: 'Product Unit of Weight',
    productValue: 'Product Value',
    originCountry: 'Origin Country',
    marksAndNumbers: 'Marks and Numbers',
  },
  COLUMN_ORDERED: [
    'Shipment Control Number',
    'Shipment Type',
    'Shipper Name',
    'Shipper Address',
    'Shipper City',
    'Shipper Country',
    'Shipper State',
    'Shipper Postal',
    'Shipper Port of Lading',
    'Consignee Name',
    'Consignee Address',
    'Consignee City',
    'Consignee Country',
    'Consignee State',
    'Consignee Postal',
    'Product Description',
    'Product Qty',
    'Product UOM',
    'Product Weight',
    'Product Unit of Weight',
    'Product Value',
    'Origin Country',
    'Marks and Numbers',
  ],
  REQUIRED_COLUMNS: [
    'Shipment Control Number',
    'Shipment Type',
    'Shipper Name',
    'Shipper Address',
    'Shipper City',
    'Shipper Country',
    'Shipper State',
    'Shipper Postal',
    'Shipper Port of Lading',
    'Consignee Name',
    'Consignee Address',
    'Consignee City',
    'Consignee Country',
    'Consignee State',
    'Consignee Postal',
    'Product Description',
    'Product Qty',
    'Product UOM',
    'Product Weight',
    'Product Unit of Weight',
    'Origin Country'
  ],
  DROPDOWN_COLUMNS: [
    'Product UOM',
    'Shipment Type',
    'Product Unit of Weight',
    'Shipper Country',
    'Consignee Country',
    'Shipper State',
    'Consignee State',
    'Shipper Port of Lading',
  ],
  FIELDS_CONSTRAINTS: {
    STRING: {
      shipperName: { min: 1, max: 45 },
      shipperAddress: { min: 1, max: 80 },
      shipperCity: { min: 1, max: 50 },
      shipperCountry: { min: 1, max: 50 },
      shipperState: { min: 1, max: 50 },
      shipperPostal: { min: 1, max: 50 },
      shipperPortOfLading: { min: 1, max: 100 },
      consigneeName: { min: 1, max: 45 },
      consigneeAddress: { min: 1, max: 80 },
      consigneeCity: { min: 1, max: 50 },
      consigneeCountry: { min: 1, max: 50 },
      consigneeState: { min: 1, max: 50 },
      consigneePostal: { min: 1, max: 50 },
      productDescription: { min: 1, max: 45 },
      originCountry: { min: 1, max: 45 },
      marksAndNumbers: { min: 1, max: 45 }
    },
    NUMBER: ['productQty', 'productWeight', 'productValue'],
  },
};

export const SHIPMENT_BULK_COUNTRIES = {
  MX: {
    code: 'MX',
    labelVariants: ['mx', 'mex', 'mexico'],
  },
  CA: {
    code: 'CA',
    labelVariants: ['ca', 'canada'],
  },
  US: {
    code: 'US',
    labelVariants: ['us', 'usa', 'united states', 'united states of america'],
  },
};

export const SHIPMENT_BULK_MAX_PRODUCT_VALUE = 800;

export const SHIPMENT_BULK_VALIDATION = {
  FAILED: 'Failed',
  PASSED: 'Passed',
};

export const EQUIPMENT_INFO_KEYS = {
  PRIMARY: {
    type: {
      label: 'Type',
      key: '',
    },
    equipmentNumber: {
      label: 'Equipment Number',
      key: 'equipmentNumber',
    },
    primaryPlate: {
      label: 'Primary Plate',
      key: 'primaryPlate',
    },
    vin: {
      key: 'vin',
      label: 'VIN',
    },
    country: {
      label: 'Country',
      key: 'primaryPlateCountryCode',
    },
    state: {
      label: 'Province/State',
      key: 'primaryPlateStateCode',
    },
    leased: {
      label: 'Leased',
      key: '',
    },
  },
  SECONDARY: {
    make: {
      label: 'Make',
      key: 'make',
    },
    modelYear: {
      label: 'Model Year',
      key: 'modelName',
    },
    style: {
      label: 'Style',
      key: 'style',
    },
    secondaryPlate: {
      label: 'Secondary Plate',
      key: 'secondaryPlate',
    },
    secondaryPlateCountry: {
      label: 'Secondary Plate Country',
      key: 'secondaryPlateCountryCode',
    },
    state: {
      label: 'State',
      key: 'secondaryPlateStateCode',
    },
    trackingIMEI: {
      label: 'Tracking IMEI',
      key: 'locationCode',
    },
    bondInfo: {
      label: 'Bond Info',
      key: '',
    },
  },
};

export const CONVEYANCE_INFO_KEYS = {
  PRIMARY: {
    type: { label: 'Type', key: 'conveyanceTypeCode' },
    conveyanceNumber: { label: 'Conveyance Number', key: 'conveyanceNumber' },
    primaryPlate: { label: 'Primary Plate', key: 'conveyancePrimaryPlate' },
    vin: { label: 'VIN', key: 'conveyanceVIN' },
    country: { label: 'Country', key: 'conveyanceCountryCode' },
    state: { label: 'Providence/State', key: 'conveyanceStateCode' },
  },
};

export const IIT_TYPES = [
  {
    name: 'Carrier Bond (empty)',
    value: 'C',
  },
  {
    name: 'Importer Bond (empty)',
    value: 'I',
  },
  {
    name: 'Carrier Bond (loaded)',
    value: 'A',
  },
  {
    name: 'Importer Bond (loaded)',
    value: 'B',
  },
];

export const IIT_SEALS_TYPES = {
  EQUIPMENT: 'equipment',
  CONVEYANCE: 'conveyance',
};

export const PAGINATOR_DEFAULTS = {
  pageNumber: 1,
  totalPerPage: 20,
  numberOfPages: 1,
  total: 1,
  totalInPage: 10,
};

export const DOCUMENTS = {
  RECEIPT: 'receipt',
  DOC7533: 'document7533',
  DOC7533ENTRY: 'document7533Entry',
  DOC7523: 'document7523',
  COVERSHEET: 'coversheet',
  RECEIPTCA: 'receipt-ca',
  EQRCOVERSHEET: 'enlargedQR',
  MANIFEST: 'manifest',
  COVERSHEET321: 'coversheet321',
};

export const SELECTED_ORG = 'organizationId';
export const SELECTED_LANGUAGE = 'language';
export const SELECTED_ROLE = 'role';
export const MAX_TRIP_EQUIPMENTS = 4;
/** Max passengers selectable per trip (e.g. bus groups). */
export const MAX_TRIP_PASSENGERS = 20;
export const MIN_CHARACTERS_AFTER_SEARCH = 1;
export const MAX_NOTE_INPUT_LENGTH = 160;

export const DASHBOARD_COLUMNS = {
  PENDING: { label: 'Pending', value: 'pending' },
  AWAITING: { label: 'Awaiting Customs', value: 'awaiting' },
  DISPATCH: { label: 'Ready for Dispatch', value: 'dispatch' },
  RELEASED: { label: 'Released', value: 'released' },
};

export const TRIP_TYPES = {
  conveyanceOnly: { value: 'conveyanceOnly', label: 'Conveyance Only' },
  emptyEquipment: { value: 'emptyEquipment', label: 'Empty Equipment' },
  hazmat: { value: 'hazmat', label: 'Hazmat' },
  regular: { value: 'regular', label: 'Regular' }
};

export const TRIP_STATUS_OPTIONS = {
  accepted: { value: 'accepted', label: 'Accepted' },
  arrived: { value: 'arrived', label: 'Arrived' },
  draft: { value: ['inactive'], label: 'Draft' },
  entryOnFile: { value: 'entryOnFile', label: 'Entry On File' },
  entryNotOnFile: { value: 'entryNotOnFile', label: 'Entry Not On File' },
  rejected: { value: 'rejected', label: 'Rejected' },
  released: { value: 'released', label: 'Released' },
};


export const CUSTOMS_BORDER_OPTIONS = {
  cbp: { value: 'cbp', label: 'CBP' },
  cbsa: { value: 'cbsa', label: 'CBSA' }
};

export const INTERVAL_BEFORE_FORCE_PAGE_RELOADING = 120000;

export const TRIP_SUMMARY_HAS_TRIP_CHANGE_KEY = 'TRIP_SUMMARY_HAS_TRIP_CHANGE_KEY';

export const ACCEPTED_STATUS = [
  'acceptedTripPortion',
  'acceptedClosingTrip',
  'acceptedUpdateTripPortion',
  'acceptedUpdateClosingTrip',
  'accepted',
  'editionAccepted',
  'arrived',
  'released',
  'entryOnFile',
  'entryNotOnFile'];

